import { text } from "svelte/internal";
import { AudioManager, Track } from "../../AudioManager";
import { SetStyles, Point, Size, CreateElement, LogGroup, Scale} from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Settings } from "../../Settings";
import { CanvasSprite, CanvasSpriteSizing } from "../Sprite/CanvasSprite";
import { ICometInterface, ICometInterfacePIXIAPP } from "./ICometInterface";
import * as PIXI from 'pixi.js';
import { AwardPositionWithValue } from "../../api";
import { S2_SpinnableReelsBigCanvas2 } from "../SpinAnimation2/SpinnableReelsBigCanvas2";
export class CometDefaultPIXIAPP implements ICometInterfacePIXIAPP
{
    protected canvasSprite: CanvasSprite;

    
    // protected topCenterOffset: number = 0.42;
    // protected bottomCenterOffset: number= 0.197;
    // protected rotateOrigin: string = "50% 87%";
    protected view : HTMLElement = null;
    protected audio : AudioManager = null;
    protected resid : ResourceIdentifier = null;
    protected viewPIXIAPP : PIXI.Container = null; 
    protected spriteContainerPIXIAPP : PIXI.Container = null; 
    protected cometAnimatedSprite : PIXI.AnimatedSprite = null
    protected cometAnimatedSpriteSize: Size;
    //protected reelsCoverAnotherScreen : boolean = null;
    protected OriginOffsetY : number = 0 ;
    protected fps : number = 0;
    public constructor(audio : AudioManager , resid : ResourceIdentifier , reelsCoverAnotherScreen : boolean , fps : number){
        this.audio = audio;       
        this.resid = resid;
        //this.reelsCoverAnotherScreen = reelsCoverAnotherScreen;
        this.fps = fps;
    }
    StartSpineComet(source: Point, dest: Point, currentScatterCometIndex: number): void {
        throw new Error("Method not implemented.");
    }
    CreateSpine(scatterPositions?: AwardPositionWithValue[], spinnableReels?: S2_SpinnableReelsBigCanvas2): PIXI.Container {
        throw new Error("Method not implemented.");
    }
    Destroy() {
        throw new Error("Method not implemented.");
    }
    Skip(currentScatterCometIndex: number, dest: Point, scatterPositions: AwardPositionWithValue[], spinnableReels2: S2_SpinnableReelsBigCanvas2, limitSkip: number) {
        throw new Error("Method not implemented.");
    }
   
    public ViewPIXIAPP(): PIXI.Container {
        return this.viewPIXIAPP;
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder +  "multigame/slot/common/resources/HoldAndSpin/resources/cometShort", ResourceIdentifier.Global.Add("BonusWinShow").Add("Commet"), true, LogGroup.Global.Add("BonusWinShow").Add("Commet"), true))
        this.audio.AddTrack(new Track(Settings.ResourcesFolder +  "multigame/slot/common/resources/HoldAndSpin/resources/tracks/cometShort" + Settings.audioFormat, this.resid.ScopedResourceName("comet")));
    }
    protected TexturesCometFrame : PIXI.Texture [] = [];
    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        this.canvasSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BonusWinShow").Add("Commet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});
        let sprite = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BonusWinShow").Add("Commet")).sprite;


        //let TexturesCometFrame : PIXI.Texture [] = [];
        for (let decodedFrames of sprite.shared.decodedFrames) {         
            let symbolTexture= PIXI.Texture.from(decodedFrames);
            this.TexturesCometFrame.push(symbolTexture);
        }

        // this.viewPIXIAPP = new PIXI.Container();
        // this.viewPIXIAPP.name = "cometViewPIXIAPP";
        // //this.viewPIXIAPP.width = Settings.ScreenWidth;
        // //this.viewPIXIAPP.height = Settings.ScreenHeight * Settings.Screens;
        // if(this.reelsCoverAnotherScreen == false )this.viewPIXIAPP.y = Settings.ScreenHeight * (Settings.Screens - 1);
        
        
        // this.spriteContainerPIXIAPP = new PIXI.Container();
        // this.spriteContainerPIXIAPP.name = "spriteContainerPIXIAPP";
        // this.spriteContainerPIXIAPP.width = this.canvasSprite.sprite.Size().width;
        // this.spriteContainerPIXIAPP.height = this.canvasSprite.sprite.Size().height;        
        // //this.spriteContainerPIXIAPP.pivot.set(this.canvasSprite.Size().width/2,this.canvasSprite.Size().height /2 );
        // this.viewPIXIAPP.addChild(this.spriteContainerPIXIAPP);
       

        // this.cometAnimatedSprite =  new PIXI.AnimatedSprite(this.TexturesCometFrame);
        // this.cometAnimatedSprite.width = this.canvasSprite.sprite.Size().width;
        // this.cometAnimatedSprite.height = this.canvasSprite.sprite.Size().height;
        // this.cometAnimatedSprite.onComplete=()=>{
        //     this.SpriteComplete();
        // }
        // //this.cometAnimatedSprite.anchor.set(0.5,1);
        // this.cometAnimatedSprite.loop = false;
        // this.cometAnimatedSprite.visible = false;
        // this.spriteContainerPIXIAPP.addChild(this.cometAnimatedSprite);

        // //this.OriginOffsetY = 0.87 * this.canvasSprite.sprite.Size().height;
        // //console.log("CenterOriginPivot-SizeHeight:",this.canvasSprite.sprite.Size().height);
        // //console.log("CenterOriginPivot:",this.OriginOffsetY);
    }

    public Start(source: Point, dest: Point)
    {
        //restart pixi anim 
        this.cometAnimatedSprite.gotoAndStop(0);
        // Define the points on the texture

        
        // const textureStart = { x: Scale.X(148), y: Scale.Y(544) }; // Example coordinates on the texture
        // const textureEnd = { x: Scale.X(148), y: Scale.Y(155) }; // Example coordinates on the texture

        const textureStart = {x: this.cometAnimatedSpriteSize.Width * 0.4789, y: this.cometAnimatedSpriteSize.Height * 0.9066};
        const textureEnd = {x: this.cometAnimatedSpriteSize.Width * 0.4789, y: this.cometAnimatedSpriteSize.Height * 0.2583};
        
        console.log("CometPIXI.Start() Sprite size: ", this.cometAnimatedSpriteSize);
        console.log("CometPIXI.Start() Start: ", textureStart);
        console.log("CometPIXI.Start() End: ", textureEnd);

        // Define the target points on the screen
        const targetStart = source; //{ x: 200, y: 200 }; // Desired screen coordinates
        const targetEnd = dest; //{ x: 600, y: 500 }; // Desired screen coordinates

        // Create a sprite with the texture
        const sprite = this.cometAnimatedSprite; //new PIXI.Sprite(texture);

        // Calculate the distance between the points
        const distanceTexture = Math.sqrt((textureEnd.x - textureStart.x) ** 2 + (textureEnd.y - textureStart.y) ** 2);
        const distanceTarget = Math.sqrt((targetEnd.x - targetStart.x) ** 2 + (targetEnd.y - targetStart.y) ** 2);

        // Calculate the scale factor
        const scale = distanceTarget / distanceTexture;
        sprite.scale.set(scale);

        // Calculate the angle between the points
        const angleTexture = Math.atan2(textureEnd.y - textureStart.y, textureEnd.x - textureStart.x);
        const angleTarget = Math.atan2(targetEnd.y - targetStart.y, targetEnd.x - targetStart.x);
        const rotation = angleTarget - angleTexture;
        sprite.rotation = rotation;

        // Adjust for rotation around the correct pivot
        sprite.pivot.set(textureStart.x, textureStart.y);

        // Position the sprite such that the texture's start point aligns with the target start point
        sprite.position.set(targetStart.x, targetStart.y);
       
        this.cometAnimatedSprite.play();           
        this.cometAnimatedSprite.visible = true;
        //this.cometAnimatedSprite.scale.set(scaleWidth,scaleHeight);
    }

    public StopsCommets() {
        //this.canvasSprite.Stop();
        //this.canvasSprite.Hide();
        this.cometAnimatedSprite.stop();
        this.cometAnimatedSprite.visible = false;
        this.cometAnimatedSprite.gotoAndStop(0);
    }

    public OnCompleteCallback: () => void = null;
    public SpriteComplete(): void {
        //this.canvasSprite.Hide();
        this.cometAnimatedSprite.visible = false;        
        this.OnCompleteCallback?.();
    }

    public View(): HTMLElement
    {
        return null;
    }

    public Update(): void
    {
        //this.canvasSprite.Update();
    }

    public PlayCometSound(){
		this.audio.Play(this.resid.ScopedResourceName("comet"));
	}

    public StopCometSound(){
		this.audio.Stop(this.resid.ScopedResourceName("comet"));
	}

    public CreatePIXIAPP() : PIXI.Container{
        this.viewPIXIAPP = new PIXI.Container();
        this.viewPIXIAPP.name = "cometViewPIXIAPP";
        //this.viewPIXIAPP.width = Settings.ScreenWidth;
        //this.viewPIXIAPP.height = Settings.ScreenHeight * Settings.Screens;
        //if(this.reelsCoverAnotherScreen == false )this.viewPIXIAPP.y = Settings.ScreenHeight * (Settings.Screens - 1);
        
        
        this.spriteContainerPIXIAPP = new PIXI.Container();
        this.spriteContainerPIXIAPP.name = "spriteContainerPIXIAPP";
        this.spriteContainerPIXIAPP.width = this.canvasSprite.sprite.Size().Width;
        this.spriteContainerPIXIAPP.height = this.canvasSprite.sprite.Size().Height;        
        //this.spriteContainerPIXIAPP.pivot.set(this.canvasSprite.Size().width/2,this.canvasSprite.Size().height /2 );
        this.viewPIXIAPP.addChild(this.spriteContainerPIXIAPP);
       

        this.cometAnimatedSprite = new PIXI.AnimatedSprite(this.TexturesCometFrame); 
        //this.cometAnimatedSprite.animationSpeed = this.fps / this.cometAnimatedSprite.totalFrames;       
        this.cometAnimatedSprite.width = this.canvasSprite.sprite.Size().Width;
        this.cometAnimatedSprite.height = this.canvasSprite.sprite.Size().Height;

        this.cometAnimatedSpriteSize = new Size(this.cometAnimatedSprite.width, this.cometAnimatedSprite.height);

        this.cometAnimatedSprite.onComplete=()=>{
            this.SpriteComplete();
        }
        //this.cometAnimatedSprite.anchor.set(0.5,1);
        this.cometAnimatedSprite.loop = false;
        this.cometAnimatedSprite.visible = false;
        this.spriteContainerPIXIAPP.addChild(this.cometAnimatedSprite);

        //this.OriginOffsetY = 0.87 * this.canvasSprite.sprite.Size().height;
        //console.log("CenterOriginPivot-SizeHeight:",this.canvasSprite.sprite.Size().height);
        //console.log("CenterOriginPivot:",this.OriginOffsetY);

        return this.viewPIXIAPP;
    }

    

    public UpdateCometAnimation(celebrationFactor: number) {
        this.canvasSprite.sprite.SetFPS(this.canvasSprite.sprite.GetFPS()*celebrationFactor)
        
    }
}